<template>
  <div class="MainCard">
    <div class="titlePart">
      <div class="title" v-text="currentInfo.title"></div>
      <div class="tip" v-text="currentInfo.tip"></div>
    </div>
    <div class="stepList">
      <div class="stepItem" v-for="(item, index) in currentInfo.stepList" :key="index">
        <div class="leftPart">
          <div class="title" v-text="item.title"></div>
          <div class="tip" v-text="item.tip"></div>
        </div>
        <van-image fit="contain" class="examplePic" lazy-load :src="youpPath + item.pic" />
      </div>
    </div>
    <van-button type="info" round size="normal" class="copyKeyWard" @click="IknowBtnHandler">
      我知道了
    </van-button>
  </div>
</template>

<script>
import { Button } from 'vant'
import { IMG_BASE_URL } from '@/config'
export default {
  name: 'SouhuoH5Maincard',

  data() {
    return {
      youpPath: IMG_BASE_URL,
      // 视频口令模式
      videoWordMode: {
        // 0：淘宝（默认）、1：京东、2：拼多多、3抖音
        3: {
          title: '复制口令打开抖音App，进入视频',
          tip: '根据下方步骤，找到对应商品',
          stepList: [
            {
              title: '1.点击购物入口',
              tip: '点击视频左下方的商品购物入口，打开商品窗口',
              pic: '/upaiyun/Sys/20220424/5123691866163916600.jpg'
            },
            {
              title: '2.查看商品详情',
              tip: '点击商品标题，进入商品详情页，完成下一步的答题验证，请勿直接购买',
              pic: '/upaiyun/Sys/20220424/5720559100212350245.jpg'
            }
          ]
        }
      },
      // 直播口令模式
      liveWordMode: {
        // 0：淘宝（默认）、1：京东、2：拼多多、3抖音
        0: {
          title: '复制口令打开淘宝APP，进入直播间',
          tip: '根据下方步骤，找到对应商品',
          stepList: [
            {
              title: '1.点击购物车',
              tip: '点击直播间左下角的购物车，打开商品列表',
              pic: '/upaiyun/Sys/20220424/5322901787617790392.jpg'
            },
            {
              title: '2.核实商品主图',
              tip: '在列表中找到与商品图片一致的商品，点击去购买',
              pic: '/upaiyun/Sys/20220424/5536058710958305264.jpg'
            }
          ]
        },
        3: {
          title: '复制口令打开抖音APP，进入直播间',
          tip: '根据下方步骤，找到对应商品',
          stepList: [
            {
              title: '1.点击购物车',
              tip: '点击直播间右下角的购物车，打开商品列表',
              pic: '/upaiyun/Sys/20220429/5611190916292974491.jpg'
            },
            {
              title: '2.核实商品主图',
              tip: '在列表中找到与商品图片一致的商品，点击去购买',
              pic: '/upaiyun/Sys/20220429/5174519637326903951.jpg'
            }
          ]
        }
      },
      // 二维码模式
      qrCodeMode: {
        // 0：淘宝（默认）、1：京东、2：拼多多、3抖音
        0: {
          title: '保存二维码，打开淘宝App扫一扫进行购买',
          tip: '根据下方步骤，扫描二维码找到对应商品',
          stepList: [
            {
              title: '1.点击扫一扫',
              tip: '打开淘宝App，点击扫一扫',
              pic: '/upaiyun/Sys/20220425/5512518228661480783.jpg'
            },
            {
              title: '2.选择二维码',
              tip: '选择已保存的二维码图片进行识别',
              pic: '/upaiyun/Sys/20220425/4685737918032708144.jpg'
            }
          ]
        },
        1: {
          title: '保存二维码，打开京东App扫一扫进行购买',
          tip: '根据下方步骤，扫描二维码找到对应商品',
          stepList: [
            {
              title: '1.点击扫一扫',
              tip: '打开京东App，点击扫一扫',
              pic: '/upaiyun/Sys/20220425/4837880391263368374.jpg'
            },
            {
              title: '2.选择二维码',
              tip: '选择已保存的二维码图片进行识别',
              pic: '/upaiyun/Sys/20220425/4823794287407554636.jpg'
            }
          ]
        },
        2: {
          title: '保存二维码，打开拼多多App扫一扫进行购买',
          tip: '根据下方步骤，扫描二维码找到对应商品',
          stepList: [
            {
              title: '1.点击扫一扫',
              tip: '选择首页顶部相机图标，再点击右上角扫一扫',
              pic: '/upaiyun/Sys/20220425/5230489052522674664.jpg'
            },
            {
              title: '2.选择二维码',
              tip: '选择已保存的二维码图片进行识别',
              pic: '/upaiyun/Sys/20220425/4723002675972083756.jpg'
            }
          ]
        },
        3: {
          title: '保存二维码，打开抖音App扫一扫进行购买',
          tip: '根据下方步骤，扫描二维码找到对应商品',
          stepList: [
            {
              title: '1.点击扫一扫',
              tip: '选择首页顶部搜索图标，再点击右上角扫一扫',
              pic: '/upaiyun/Sys/20220425/5102987964963659765.jpg'
            },
            {
              title: '2.选择二维码',
              tip: '选择已保存的二维码图片进行识别',
              pic: '/upaiyun/Sys/20220425/5569735039084723036.jpg'
            }
          ]
        }
      }
    }
  },

  props: {
    // 当前页面信息
    currentPageInfo: {
      type: Object,
      default: () => {
        return null
      }
    }
  },

  computed: {
    currentInfo() {
      let tempObj = {}
      let platform = this.currentPageInfo.platform // 平台 --> 0：淘宝（默认）1：拼多多、2：京东、3抖音
      let indexStep = this.currentPageInfo.indexStep // 当前步骤
      let haveScreen = this.currentPageInfo.haveScreen // 是否有筛选条件
      let SearchType = this.currentPageInfo.SearchType // App自然搜索 = 0, PC自然搜索 = 1, APP直通车 = 2, PC直通车 = 3, 分享口令 = 4, 视频口令 = 5, 直播口令 = 6, 二维码 = 7
      switch (SearchType) {
        case 5:
          // 视频口令模式
          tempObj = this.videoWordMode[platform]
          break
        case 6:
          // 直播口令模式
          tempObj = this.liveWordMode[platform]
          break
        case 7:
          // 二维码模式
          tempObj = this.qrCodeMode[platform]
          break
      }
      return tempObj
    }
  },

  components: {
    'van-button': Button
  },

  mounted() {
    // console.log(this.currentPageInfo)
    // this.currentInfo = this.dyStepOneOfVideo
  },

  methods: {
    IknowBtnHandler() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.MainCard {
  position: relative;
  width: 100%;
  background-color: #fff;
  padding: 16px 12px 12px;
  box-sizing: border-box;
  border-radius: 6px;

  .titlePart {
    .title {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 4px;
    }
    .tip {
      font-size: 12px;
      color: #a2a2a2;
    }
  }

  .stepList {
    .stepItem {
      display: flex;
      align-items: center;
      background-color: #f5f6f9;
      padding: 12px;
      margin-top: 10px;
      .leftPart {
        flex: 1;
        font-size: 14px;
        .title {
          color: #46a6fe;
          margin-bottom: 6px;
        }
        .tip {
          color: #a2a2a2;
          font-size: 13px;
        }
      }
      .examplePic {
        width: vw(140);
        height: vw(127);
        flex-shrink: 0;
        margin-left: 20px;
        border-radius: 6px;
        overflow: hidden;
      }
    }
  }

  .copyKeyWard {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 40px);
  }
}
</style>
